export const isAbsoluteUrl = (url) =>
  url.includes('http://') || url.includes('https://');